import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import * as Styled from './styled';

function FileInput({ name, accept }) {
  const intl = useIntl();
  const defaultInputText = intl.formatMessage({
    id: 'feedback.file-upload-text-default',
  });

  const fileInputRef = useRef();
  const [fileInputText, setFileInputText] = useState(defaultInputText);
  const fileSelected = fileInputText !== defaultInputText;

  const updateSelectedFileProp = () => {
    const selectedFile = fileInputRef.current.files[0];
    setFileInputText(selectedFile ? selectedFile.name : defaultInputText);
  };

  const onInputButtonClick = () => {
    if (fileSelected) {
      // the input's change event is not fired when it's value is changed
      // programmatically
      fileInputRef.current.value = null;
      updateSelectedFileProp();
    } else {
      fileInputRef.current.click();
    }
  };

  const onButtonKeyDown = e => {
    if (e.key === 'Enter') fileInputRef.current.click();
  };

  return (
    <>
      <Styled.FileInputContainer>
        <Styled.FileInputButton
          type="button"
          onClick={onInputButtonClick}
          onKeyDown={onButtonKeyDown}
        >
          <FormattedMessage
            id={`feedback.${
              fileSelected ? 'file-upload-remove' : 'file-upload-select'
            }`}
          />
        </Styled.FileInputButton>
        <Styled.FileInputText fileSelected={fileSelected}>
          {fileInputText}
        </Styled.FileInputText>
      </Styled.FileInputContainer>
      <Styled.HiddenInput
        type="file"
        ref={fileInputRef}
        onChange={updateSelectedFileProp}
        name={name}
        accept={accept}
      />
    </>
  );
}

FileInput.propTypes = {
  /** Value for `name` attribute of hidden, native html file input */
  name: PropTypes.string,
  /**
   * Used as value for `accept` attribute of hidden file input:
   * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#accept
   */
  accept: PropTypes.string,
};

FileInput.defaultProps = {
  name: undefined,
  accept: undefined,
};

export default FileInput;
